import { Button, Tooltip } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { changeCorrespondenceFilter } from 'Agent/Policies/ducks/policyCorrespondence';
import classNames from 'classnames';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ReducerState } from 'rootReducer';
import 'Shared/components/PagedView/Card/CardFilterOverlay.sass';
import { FilterProperties } from 'Shared/components/PagedView/Filter';


export type CorrespondenceCardFilters<TFilter> = {
  filter: FilterProperties<TFilter>;
  title: string;
};

type CorrespondenceCardFilterOverlayProps<TData, TFilter> = {
  open: boolean;
  onClose: () => void;
} & RouteComponentProps;

const CorrespondenceCardFilterOverlay = <TData, TFilter>(props: CorrespondenceCardFilterOverlayProps<TData, TFilter>) => {
  const [isFakeClosed, setIsFakeClosed] = useState(false);
  const searchCriteriaValueGlobal = useSelector(
    (state: ReducerState) => state.policyCorrespondence.searchCriteriaValue
  );
  const [searchCriteriaValue, setSearchCriteriaValue] = useState(searchCriteriaValueGlobal);
  const dispatch = useDispatch();
  const emptyFilter = Object.values(searchCriteriaValue).every(
    value => value === ''
  );
  const updateFilterValue = (label: string, value: string) => {
    setSearchCriteriaValue(values => ({
      ...values,
      [label]: value
    }))
  }

  useEffect(() => {
    setSearchCriteriaValue(searchCriteriaValueGlobal)
  }, [searchCriteriaValueGlobal]);


  return props.open ? (
    <div
      className={classNames('card-filter-overlay', {
        slideClosed: isFakeClosed,
        slideIn: !isFakeClosed,
      })}
    >
      <div className="card-filter-overlay__header__correspondence">
        <span>
          Correspondence Filters
        </span>
        <div onClick={() => {
          setIsFakeClosed(true);
          emptyFilter && props.history.push(CoreRouteConstants.DASHBOARD);
          setTimeout(() => {
            props.onClose();
            setIsFakeClosed(false);
          }, 1000);
        }}>&#x2715;</div>
      </div>
      <div className="card-filter-overlay__content">
        <Alert severity="info">
          Filter using either Account Number or Policy Number.
        </Alert>
        <div className='card-filters__correspondence'>
          <div className='column-filter'>
            <div className={`filter-label ${!searchCriteriaValue.policyNumber ? "" : "disabled"}`}>Account Number</div>
            <Tooltip title="Billing Account Number" aria-label="info">
              <input
                className='account__number'
                type="text"
                value={searchCriteriaValue.accountNumber}
                onChange={e => updateFilterValue("accountNumber", e.target.value)}
                placeholder="Enter Account Number"
                disabled={searchCriteriaValue.policyNumber.length != 0} />
            </Tooltip>
          </div>
          <div className='column-filter'>
            <div className={`filter-label ${!searchCriteriaValue.accountNumber ? "" : "disabled"}`}>Policy Number</div>
            <Tooltip title="Billing Account Number" aria-label="info">
              <input
                className='policy__number'
                type="text"
                value={searchCriteriaValue.policyNumber}
                onChange={e => updateFilterValue("policyNumber", e.target.value)}
                placeholder="Enter Policy Number"
                disabled={searchCriteriaValue.accountNumber.length != 0} />
            </Tooltip>
          </div>
        </div>
      </div>
      <div className="card-filter-overlay__actions-section correspondence">
        <Button
          className="card-filter-overlay__correspondence__button search"
          fullWidth
          color="primary"
          variant="contained"
          disabled={emptyFilter}
          onClick={() => {
            setIsFakeClosed(true);
            dispatch(changeCorrespondenceFilter(searchCriteriaValue));
            setTimeout(() => {
              props.onClose();
              setIsFakeClosed(false);
            }, 1000);
          }}
        >
          Search & Filter
        </Button>
        <Button
          className="card-filter-overlay__correspondence__button close"
          fullWidth
          variant="contained"
          onClick={() => {
            setIsFakeClosed(true);
            emptyFilter && props.history.push(CoreRouteConstants.DASHBOARD);
            setTimeout(() => {
              props.onClose();
              setIsFakeClosed(false);
            }, 1000);
          }}
        >
          Close
        </Button>
      </div>
    </div>
  ) : null;
};

export default withRouter(CorrespondenceCardFilterOverlay);
